export default "__VITE_ASSET__BtD4DMQ0__"